module.exports = __webpack_public_path__ + "static/media/ds-podium_03.21cb86d0.png";